import { TSelectOption } from 'shared/types'

export const FIELD_NAME = 'storypack'
export const FEED_FILTER_STORAGE_NAME = 'feedsFilter'
export const GLOBAL_OVERVIEW_FILTER_STORAGE_NAME = 'globalOverviewFilter'
export const PROJECT_FILTER_STORAGE_NAME = 'projectsFilters'
export const PROJECT_DETAILS_FILTER_STORAGE_NAME = 'projectDetailsFilters'
export const PRODUCTS_FILTER_STORAGE_NAME = 'productsFilter'
export const USERS_FILTER_STORAGE_NAME = 'usersFilter'
export const SUCCESS_STORIES_FILTER_STORAGE_NAME = 'successStoriesFilter'

export const FILTER_FIELDS = {
  FOLLOWED: 'followed',
  RELATION_TYPE: 'relation_type',
  UNITS: 'unit_id',
  ARCHIVED: 'archived',
  RANGE: 'range',
  TAGS: 'tags',
  LABELS: 'label_id',
  SPACES: 'space_id',
  ROLES: 'role_id',
  EXTERNAL: 'is_external',
  CONFIGURATION: 'configuration',
  GPS_STATUS: 'gps_status',
  COUNTRY: 'countryIds'
}

export const FOLLOWED_FILTER_VALUES = {
  ALL: 'all',
  FOLLOWED: 'followed',
  MY: 'my'
}

export const RANGE_FILTER_VALUES = {
  ALL: 'all',
  LAST_DAY: 'last_day',
  THIS_WEEK: 'this_week',
  LAST_WEEK: 'last_week',
  FULL_WEEK: 'full_week',
  THIS_MONTH: 'this_month',
  LAST_MONTH: 'last_month'
}

export const FORMAT_FILTER_VALUES = {
  ALL: 'all',
  SINGLE: 'single',
  ALBUM: 'album',
  EP: 'ep'
}

export const ARCHIVED_FILTER_OPTIONS: TSelectOption[] = [
  {
    label: 'Hide archived',
    value: 'hide'
  },
  {
    label: 'Show archived',
    value: 'show'
  }
]

export const FOLLOWED_FILTER_OPTIONS: TSelectOption[] = [
  {
    label: 'All Projects',
    value: ''
  },
  {
    label: 'Followed Projects',
    value: FOLLOWED_FILTER_VALUES.FOLLOWED
  },
  {
    label: 'My Projects',
    value: FOLLOWED_FILTER_VALUES.MY
  }
]

export const RANGE_FILTER_OPTIONS: TSelectOption[] = [
  {
    label: 'All to date',
    value: RANGE_FILTER_VALUES.ALL
  },
  {
    label: 'Last 24 hours',
    value: RANGE_FILTER_VALUES.LAST_DAY
  },
  {
    label: 'This week to date',
    value: RANGE_FILTER_VALUES.THIS_WEEK
  },
  {
    label: 'Last full week',
    value: RANGE_FILTER_VALUES.FULL_WEEK
  }
]

export const PRODUCTS_RANGE_FILTER_OPTIONS: TSelectOption[] = [
  {
    label: 'All to date',
    value: RANGE_FILTER_VALUES.ALL
  },
  {
    label: 'This week',
    value: RANGE_FILTER_VALUES.THIS_WEEK
  },
  {
    label: 'Last week',
    value: RANGE_FILTER_VALUES.LAST_WEEK
  },
  {
    label: 'This month',
    value: RANGE_FILTER_VALUES.THIS_MONTH
  },
  {
    label: 'Last month',
    value: RANGE_FILTER_VALUES.LAST_MONTH
  }
]

export const USER_TYPES_OPTIONS: TSelectOption[] = [
  {
    label: 'Internal',
    value: 'Internal'
  },
  {
    label: 'External',
    value: 'external'
  }
]

export const PRODUCTS_CONFIGURATION_FILTER_OPTIONS: TSelectOption[] = [
  {
    label: 'All formats',
    value: FORMAT_FILTER_VALUES.ALL
  },
  {
    label: 'Single',
    value: FORMAT_FILTER_VALUES.SINGLE
  },
  {
    label: 'Album',
    value: FORMAT_FILTER_VALUES.ALBUM
  },
  {
    label: 'Ep',
    value: FORMAT_FILTER_VALUES.EP
  }
]

export const GPS_FILTER_OPTIONS: TSelectOption[] = [
  { label: 'All', value: 'all' },
  { label: 'All GPS', value: 'allgps' },
  { label: 'Track of the week', value: 'trackoftheweek' },
  { label: 'Surging Track', value: 'surgingtrack' },
  { label: 'Radar', value: 'radar' }
]

export const PROJECT_FILTER_INIT_VALUES = {
  [FILTER_FIELDS.FOLLOWED]: 'all',
  [FILTER_FIELDS.UNITS]: 'all',
  [FILTER_FIELDS.ARCHIVED]: 'hide',
  [FILTER_FIELDS.LABELS]: 'all'
}

export const FEED_FILTER_INIT_VALUES = {
  [FILTER_FIELDS.FOLLOWED]: '',
  [FILTER_FIELDS.UNITS]: '',
  [FILTER_FIELDS.RANGE]: '',
  [FILTER_FIELDS.TAGS]: [],
  [FILTER_FIELDS.LABELS]: ''
}

export const GLOBAL_OVERVIEW_FILTER_INIT_VALUES = {
  [FILTER_FIELDS.RELATION_TYPE]: 'all',
  [FILTER_FIELDS.ARCHIVED]: 'hide'
}

export const PROJECT_DETAILS_FILTER_INIT_VALUES = {
  [FILTER_FIELDS.TAGS]: []
}

export const PRODUCTS_FILTER_INIT_VALUES = {
  [FILTER_FIELDS.FOLLOWED]: 'all',
  [FILTER_FIELDS.UNITS]: 'all',
  [FILTER_FIELDS.RANGE]: 'all',
  [FILTER_FIELDS.CONFIGURATION]: 'all',
  [FILTER_FIELDS.GPS_STATUS]: 'all',
  [FILTER_FIELDS.LABELS]: 'all'
}

export const USER_FILTER_INIT_VALUES = {
  [FILTER_FIELDS.ROLES]: 'all',
  [FILTER_FIELDS.LABELS]: 'all',
  [FILTER_FIELDS.SPACES]: 'all',
  [FILTER_FIELDS.EXTERNAL]: 'all'
}

export const SUCCESS_STORIES_FILTER_INIT_VALUES = {
  [FILTER_FIELDS.LABELS]: 'all',
  [FILTER_FIELDS.RANGE]: 'all',
  [FILTER_FIELDS.TAGS]: []
}
